<template>
<div class="content">
    <div style="display: flex;justify-content: space-around;align-items: center;font-size: 30px;font-weight: bolder;">
    <el-image
    style="height: 30px"
    :src="QWImage"
    fit="fit"></el-image>
    <i class="el-icon-right"></i>
    <el-image
    style="height: 30px"
    :src="ECImage"
    fit="fit"></el-image>
    </div>
    <div class="formbiox" >
        <el-button type="primary" @click="goExportpage">上传到EC<i class="el-icon-upload el-icon--right"></i></el-button>

        <el-button type="warning" @click="goSendPage">添加EC跟进记录<i class="el-icon-document el-icon--right"></i></el-button>
    </div>
</div>
</template>
  
<script>
  
  export default {
    name: 'IndexPage',
    data () {
      return {
        ECImage:require('@/assets/EClogo.png'),
        QWImage:require('@/assets/QWlogo.png'),
      }
    },
    methods: {
        goExportpage() {
            this.$router.push({
                path: '/export'
            })
        },
        goSendPage(){
            this.$router.push({
                path: '/send'
            })
        }
      
    }
  }
</script>
  
<style scoped>
  .content {
          
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
      padding: 20px 0;
      }
  
  .formbiox {
    width: 300px;
    min-height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  .title {
    word-wrap: break-word;
    font-size: 36rpx;
    color: #8f8f94;
  }
</style>
  